import { observable } from "mobx";
import { Type } from "class-transformer";
import ReportRequestStatus from "./reportRequestStatus";

export default class AdhocReportRequestResponse {
  id!: string;

  @observable
  createdBy!: string;

  @observable
  @Type(() => Date)
  fromDate?: Date;

  @observable
  @Type(() => Date)
  toDate?: Date;

  @observable
  @Type(() => Date)
  processedAt?: Date;

  @observable
  @Type(() => Date)
  lastRefreshedAt?: Date;

  @observable
  status!: ReportRequestStatus;
}
